"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCometChat = void 0;
const react_1 = require("react");
const useAuth_1 = require("lincd-auth/lib/hooks/useAuth");
const useCometChat = () => {
    let [isReady, setIsReady] = (0, react_1.useState)(undefined);
    let resolve, reject;
    let initialPromise = new Promise((rs, rj) => {
        resolve = rs;
        reject = rj;
    });
    const [chatPromise, setChatPromise] = (0, react_1.useState)(initialPromise);
    const auth = (0, useAuth_1.useAuth)();
    (0, react_1.useEffect)(() => {
        if (typeof window !== 'undefined' && typeof isReady === 'undefined') {
            //this prevents us from running this code twice, whilst still making sure isReady is not true
            setIsReady(false);
            const logIn = (chatInstance) => __awaiter(void 0, void 0, void 0, function* () {
                let user = yield chatInstance.ensureLoggedIn(auth.user);
                if (user) {
                    yield chatInstance.init();
                    setIsReady(true);
                    return chatInstance;
                }
                else {
                    console.warn('CometChat login failed, retrying in 2 seconds');
                    return new Promise((rs, rj) => {
                        setTimeout(() => {
                            rs(logIn(chatInstance));
                        }, 2000);
                    });
                }
            });
            //we can only import cometchat in the browser, so we dynamically import it here
            //start the import
            Promise.resolve().then(() => __importStar(require('../utils/CometChat'))).then((CometChat) => __awaiter(void 0, void 0, void 0, function* () {
                let chatInstance = new CometChat.LincdCometChat();
                if (auth.user) {
                    // console.log('Starting cometchat login');
                    logIn(chatInstance)
                        .then(() => {
                        resolve(chatInstance);
                    })
                        .catch((err) => {
                        reject(err);
                    });
                }
                else {
                    console.warn('Could not start cometchat, no user is logged in logged in.');
                }
            }));
            // setChatPromise(
            //   chatPromise
            //     .then(() => {
            //       // console.log('resolved initial, returning import promise');
            //       return importPromise;
            //     })
            //     .catch((err) => reject(err)),
            // );
            //resolve the initial promise so that it will resolve when import is done
            // resolve();
        }
    }, [auth.user, isReady]);
    return {
        ready: isReady,
        logout: (...args) => chatPromise.then((chat) => chat.logout(...args)),
        getLoggedInUser: (...args) => chatPromise.then((chat) => chat.getLoggedInUser(...args)),
        toCometChatUser: (...args) => chatPromise.then((chat) => {
            return chat.toCometChatUser(...args);
        }),
        ensureUserExists: (...args) => chatPromise.then((chat) => {
            return chat.ensureUserExists(...args);
        }),
        ensureLoggedIn: (...args) => chatPromise.then((chat) => {
            chat.ensureLoggedIn(...args);
        }),
        getGroup: (guid) => chatPromise.then((chat) => chat.getGroup(guid)),
        joinGroup: (guid, type, password) => chatPromise.then((chat) => chat.joinGroup(guid, type, password)),
        getGroupMembers: (guid, limit = 100, searchKeyword, scopes) => chatPromise.then((chat) => chat.getGroupMembers(guid, limit, searchKeyword, scopes)),
        deleteMessage: (messageId) => chatPromise.then((chat) => chat.deleteMessage(messageId)),
        callExtension: (slug, method, endpoint, data) => chatPromise.then((chat) => chat.callExtension(slug, method, endpoint, data)),
        conversationsRequestBuilder: (limit, conversationType, withTags, userTags, groupTags, tags) => chatPromise.then((chat) => chat.conversationsRequestBuilder(limit, conversationType, withTags, userTags, groupTags, tags)),
        getMessageDetails: (messageId) => chatPromise.then((chat) => chat.getMessageDetails(messageId)),
        blockUsers: (blockedUids) => chatPromise.then((chat) => chat.blockUsers(blockedUids)),
        getAllMessageTemplates: () => chatPromise.then((chat) => chat.getAllMessageTemplates()),
    };
};
exports.useCometChat = useCometChat;
//# sourceMappingURL=useCometChat.js.map